import { useMemo } from "react";
import { AuditStatus } from "../../../../utils/enums";

export const useAuditListFilters = ({
  processedAudits,
  searchQuery,
  filterStatus,
  filterAuditType,
  filterFramework,
}) => {
  const activeFiltersCount = useMemo(() => {
    let count = 0;
    if (filterAuditType) count++;
    if (filterFramework) count++;
    return count;
  }, [filterAuditType, filterFramework]);

  const hasActiveFilters = activeFiltersCount > 0;

  // Filter by search query and status on frontend (API handles audit_type and framework_id filters)
  const filteredAudits = useMemo(() => {
    let filtered = processedAudits;

    // Filter by status (Active/Completed/Archived)
    if (filterStatus === "active") {
      filtered = filtered.filter((audit) => audit.audit_status === AuditStatus.ACTIVE);
    } else if (filterStatus === "completed") {
      filtered = filtered.filter((audit) => audit.audit_status === AuditStatus.COMPLETED);
    } else if (filterStatus === "archived") {
      filtered = filtered.filter((audit) => audit.audit_status === AuditStatus.ARCHIVED);
    }
    
    // Filter by search query (client-side only)
    if (searchQuery) {
      const query = searchQuery.toLowerCase();
      filtered = filtered.filter(
        (audit) =>
          audit.framework_name?.toLowerCase().includes(query) ||
          audit.audit_type?.toLowerCase().includes(query) ||
          audit.auditor_name?.toLowerCase().includes(query)
      );
    }

    return filtered;
  }, [processedAudits, searchQuery, filterStatus]);

  return {
    filteredAudits,
    activeFiltersCount,
    hasActiveFilters,
  };
};
